package com.schoolconnect.app.feature.links

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun LinksFeatureRoute(
    onBack: () -> Unit
) {
    val viewModel = remember { LinksViewModel() }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    LinksScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack
    )
}

